import {
    createContext,
    PropsWithChildren,
    useContext,
    useEffect,
    useState,
} from 'react';
import { useSelector } from 'react-redux';
import { SettingsState, Store } from '../store/types';

type SearchContextType = {
    strictType: boolean;
    type?: string;
    setSearchType: (newType: string | undefined) => void;
    toggleStrict: () => void;
};

const defaultSearchContext = {
    strictType: false,
    type: undefined,
    setSearchType: () => {},
    toggleStrict: () => {},
};

const SearchContext = createContext<SearchContextType>(defaultSearchContext);

export const useSearchContext = () => {
    return useContext(SearchContext);
};

export const useSearchContextSelector = (type: string | undefined) => {
    const { setSearchType } = useSearchContext();

    useEffect(() => {
        setSearchType(type);
    }, [type]);
};

export default function SearchContextProvider({ children }: PropsWithChildren) {
    const { globalSearch } = useSelector<Store, SettingsState>(
        state => state.settings,
    );

    const [type, setType] = useState<string>();
    const [strictType, setStrictType] = useState(!globalSearch);

    useEffect(() => {
        if (globalSearch === strictType) {
            setStrictType(!globalSearch);
        }
    }, [globalSearch]);

    const setSearchType = (newType: string | undefined) => {
        setType(newType);
    };

    const toggleStrict = () => {
        setStrictType(!strictType);
    };

    const value = {
        type,
        strictType,
        setSearchType,
        toggleStrict,
    };

    return (
        <SearchContext.Provider value={value}>
            {children}
        </SearchContext.Provider>
    );
}
